import React from 'react'
import { InputNumber, Space, Typography } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type TimeDurationValue = {
  years?: number
  months?: number
  days?: number
}

type TimeDurationInputProps = {
  value?: TimeDurationValue;
  onChange?: (value: TimeDurationValue) => void;
  disabled?: boolean
}

type AntdFormTimeDurationInputProps = {
  disabled?: boolean
} & AntdFormItemProps

export const TimeDurationInput: React.FC<TimeDurationInputProps> = ({ value = {}, onChange, disabled = false }) => {
  const triggerChange = (changedValue: TimeDurationValue) => {
    onChange?.({ ...value, ...changedValue })
  }

  const onFieldValueChange = (fieldName: string, newVal: number | null) => {
    const newNumber = newVal || 0
    triggerChange({ [fieldName]: newNumber })
  }

  return (
    <Space.Compact className={cn('w-full')}>
      <InputNumber
        value={value?.years}
        onChange={val => onFieldValueChange('years', val)}
        disabled={disabled}
        suffix={<Typography.Text className="text-xs">y</Typography.Text>}
      />
      <InputNumber
        value={value?.months}
        onChange={val => onFieldValueChange('months', val)}
        disabled={disabled}
        suffix={<Typography.Text className="text-xs">m</Typography.Text>}
      />
      <InputNumber
        value={value?.days}
        onChange={val => onFieldValueChange('days', val)}
        disabled={disabled}
        suffix={<Typography.Text className="text-xs">d</Typography.Text>}
      />
    </Space.Compact>
  )
}

export const AntdFormTimeDurationInput: React.FC<AntdFormTimeDurationInputProps> = ({
  fieldProps,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <TimeDurationInput {...props} />
    </AntdFormItem>
  )
}
